import { render, staticRenderFns } from "./app-role-permission-settings.vue?vue&type=template&id=010e6152&scoped=true&"
import script from "./app-role-permission-settings.vue?vue&type=script&lang=js&"
export * from "./app-role-permission-settings.vue?vue&type=script&lang=js&"
import style0 from "./app-role-permission-settings.vue?vue&type=style&index=0&id=010e6152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010e6152",
  null
  
)

export default component.exports